export default __webpack_public_path__ + "crane_black.a7a4b01f.svg";